module.exports = __webpack_public_path__ + "img/s3_img-s.af334bbb.png";